import type { ErrorEvent } from "@sentry/react";

// A `fetch()` that never got a response surfaces as `TypeError: Failed to fetch`
// (Safari: `Load failed`), and the SDK's fetch instrumentation appends the
// target host: "Failed to fetch (mobtranslate.mobsuccess.ai)". Sentry then
// groups on the stacktrace, so the same unreachable host reached from two call
// sites (i18n bundle refresh, session log) makes two issues four seconds apart.
// The host is what identifies the failure; the caller is not.
//
// Returns null for anything else, leaving Sentry's default grouping alone.
export function getFetchFailureFingerprint(
  event: ErrorEvent,
): Array<string> | null {
  const failure = event.exception?.values?.find(
    (value) =>
      value.type === "TypeError" &&
      typeof value.value === "string" &&
      FETCH_FAILURE_MESSAGE.test(value.value),
  );
  if (!failure?.value) {
    return null;
  }
  const host = FETCH_FAILURE_MESSAGE.exec(failure.value)?.groups?.host;
  return ["fetch-failure", host ?? "unknown-host"];
}

const FETCH_FAILURE_MESSAGE =
  /^(?:Failed to fetch|Load failed|NetworkError when attempting to fetch resource\.?)(?: \((?<host>[^)]+)\))?$/;
